import { render, staticRenderFns } from "./carousel.vue?vue&type=template&id=9de4bf28&scoped=true&"
import script from "./carousel.vue?vue&type=script&lang=ts&"
export * from "./carousel.vue?vue&type=script&lang=ts&"
import style0 from "./carousel.vue?vue&type=style&index=0&id=9de4bf28&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9de4bf28",
  null
  
)

export default component.exports